import type { ListenResult, QrScanResult } from './types';

type FlowStopDependencies = {
  abortController: AbortController | null;
  stopRemoteSpeech: () => void;
  cleanupRemoteLeds: () => void;
  setFlowMotion: (motion: null) => void;
  setSayText: (sayText: null) => void;
  setTofScan?: (tof: null) => void;
  finalizeQrScan: (result: QrScanResult) => void;
  finalizeListen: (result: ListenResult) => void;
};

export const stopFlowExecution = ({
  abortController,
  stopRemoteSpeech,
  cleanupRemoteLeds,
  setFlowMotion,
  setSayText,
  setTofScan,
  finalizeQrScan,
  finalizeListen,
}: FlowStopDependencies) => {
  abortController?.abort();
  stopRemoteSpeech();
  cleanupRemoteLeds();
  setFlowMotion(null);
  setSayText(null);
  setTofScan?.(null);
  finalizeQrScan({ status: 'cancelled' });
  finalizeListen({ status: 'cancelled' });
};
